import React from "react";
import { Card } from "@mui/material";

import DashUsers from "./components/DashUsers";

function DashUsersStatus() {
  return (
    <Card sx={{ backgroundColor: "green" }}>
      <DashUsers />
    </Card>
  );
}

export default DashUsersStatus;
